/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, {useState} from 'react';

const CustomCheckbox = props => {
    
    // functional component's return
    return (
        <div className="my-2" style={{ fontSize: "xx-large" }} onClick={props.toggleIsChanged}>
            {
                props.isChecked
                ? <span><i className="far fa-check-square"></i></span>
                : <span><i className="far fa-square"></i></span>
            }
        </div>
    )

}

export default CustomCheckbox;